
export enum MessageBroadcastStatusEnum {
    PENDING = 0,
    SENT = 1,
}
